高精度地形产品
<template>
  <div class="main-div">
    <div class="chanpin">
      <h2>产品介绍</h2>
      <br />
      <p class="text_desc">基于资源三号系列卫星立体相对数据，生成10米格网DSM和DEM数据产品。</p>
    </div>
    <div class="chenguo">
      <div class="chenguo_img">
        <el-image
          fit="contain"
          src="../../../../static/officeImg/index/terrain1.webp"
          alt
          class="chenguo_img_img"
        />
        <el-image
          src="../../../../static/officeImg/index/terrain2.webp"
          alt
          fit="contain"
          class="chenguo_img_img"
        />
      </div>
    </div>
    <!-- 获取方式 -->
    <p class="quyuOne_h2">数据获取方式</p>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="date" label="项目"></el-table-column>
      <el-table-column prop="name" label="交易方式"></el-table-column>
      <el-table-column prop="address" label="生产周期"></el-table-column>
      <el-table-column prop="phone" label="购买渠道"></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //表格
      tableData: [
        {
          date: "高清影像",
          name: "存档，或按项目区域定制",
          address: "存档数据5个工作日内交付",
          phone: "采购电话：18610570353（葛经理）",
        },
      ],
    };
  },
  methods: {},
};
</script>
<style scoped>
.main-div {
  width: 70%;
  height: 1000px;
  margin: 0 auto;
}
.chanpin {
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 18px;
}
.chanpin h2 {
  font-size: 22px;
  color: #1c72dc;
  text-align: center;
}
.text_desc {
  letter-spacing: 5px;
  text-indent: 38px;
  text-align: left;
}
/* 成果 */
.chenguo {
  width: 100%;
  height: 300px;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  color: #1c72dc;
  margin: 40px 0px;
}
.chenguo_img {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chenguo_img_img {
  display: block;
  width: 40%;
  height: 480px;
  margin: 15px;
}
/* 数据获取方式 */
.quyuOne_h2 {
  font-size: 20px;
  font-weight: normal;
  color: #1c72dc;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/remoteDigData/components/terrain.vue